<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}">
						<h4 class="card-title d-flex align-items-center">
							<mat-icon class="mr-2 cursor-pointer" (click)="back()">arrow_back</mat-icon>
							General Posting Setup
						</h4>
					</div>
					<div class="card-body">
						<div class="text-end d-flex flex-wrap justify-content-end gap-2">
							<button mat-raised-button color="accent" type="button" (click)="openNew()">New row</button>
							<button mat-stroked-button type="button" (click)="toggleForm()">
								{{ isFormVisible ? 'Hide form' : 'Show form' }}
							</button>
							<button mat-raised-button color="primary" type="button" *ngIf="rows.length" (click)="exportExcel()">
								<i class="fa fa-file-excel-o"></i> Export Excel
							</button>
						</div>

						<mat-form-field appearance="outline" class="w-100 mt-3">
							<mat-label>Search</mat-label>
							<input matInput [(ngModel)]="searchTerm" name="gpsSearch" />
						</mat-form-field>

						<div *ngIf="isLoading" class="text-center py-4">
							<mat-spinner diameter="40"></mat-spinner>
						</div>

						<div *ngIf="isFormVisible && !isLoading" [@expandCollapse] class="form-container p-3 border rounded shadow-sm bg-light mt-3">
							<form [formGroup]="form" (ngSubmit)="save()">
								<h5 class="text-primary mb-3">{{ editingRow ? 'Edit row' : 'New row' }}</h5>
								<div class="row g-3">
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Business posting group</mat-label>
											<input matInput formControlName="gen_bus_posting_group" required />
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Product posting group</mat-label>
											<input matInput formControlName="gen_prod_posting_group" required />
										</mat-form-field>
									</div>
									<div class="col-md-4 d-flex align-items-center">
										<mat-slide-toggle formControlName="blocked">Blocked</mat-slide-toggle>
									</div>
									<div class="col-12">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Description</mat-label>
											<input matInput formControlName="description" />
										</mat-form-field>
									</div>
								</div>

								<mat-divider class="my-3"></mat-divider>
								<h6 class="text-muted mb-2">G/L accounts</h6>
								<div class="row g-2">
									<div class="col-md-6" *ngFor="let f of accountFields">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>{{ f.label }}</mat-label>
											<mat-select [formControlName]="f.key" required>
												<mat-option *ngFor="let c of glCodesWithZero" [value]="c.code">
													{{ c.code }} — {{ c.name }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
								</div>

								<div class="text-end mt-3">
									<button mat-stroked-button type="button" class="mr-2" (click)="resetForm(); isFormVisible = false">Cancel</button>
									<button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
										{{ editingRow ? 'Update' : 'Add' }}
									</button>
								</div>
							</form>
						</div>

						<div class="table-responsive mt-4" *ngIf="!isLoading">
							<table class="table table-striped table-hover table-bordered table-sm">
								<thead class="thead-dark">
									<tr>
										<th>Bus. group</th>
										<th>Prod. group</th>
										<th>Description</th>
										<th class="text-center">Blocked</th>
										<th>Sales</th>
										<th>COGS</th>
										<th class="text-center"></th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let r of filteredRows()">
										<td>{{ r.gen_bus_posting_group }}</td>
										<td>{{ r.gen_prod_posting_group }}</td>
										<td>{{ r.description }}</td>
										<td class="text-center">{{ r.blocked ? 'Y' : '' }}</td>
										<td>{{ r.sales_account }}</td>
										<td>{{ r.cogs_account }}</td>
										<td class="text-nowrap text-center">
											<button mat-icon-button type="button" color="primary" (click)="editRow(r)" matTooltip="Edit">
												<mat-icon>edit</mat-icon>
											</button>
											<button mat-icon-button type="button" color="warn" (click)="deleteRow(r)" matTooltip="Delete">
												<mat-icon>delete</mat-icon>
											</button>
										</td>
									</tr>
								</tbody>
							</table>
							<p *ngIf="!filteredRows().length" class="text-muted">No rows match the filter.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
